import { render } from "./ImportExcelWelcome.vue?vue&type=template&id=359e7ec2"
import script from "./ImportExcelWelcome.vue?vue&type=script&lang=js"
export * from "./ImportExcelWelcome.vue?vue&type=script&lang=js"
script.render = render

export default script